var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationDot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 9C3 4.03125 7.03125 0 12 0C16.9688 0 21 4.03125 21 9C21 11.9686 20.1439 13.1932 16.0585 19.0371C15.1766 20.2985 14.1442 21.7753 12.9375 23.5312C12.4688 24.1406 11.5312 24.1406 11.0625 23.5312C9.85578 21.7753 8.82342 20.2985 7.94152 19.0371C3.85612 13.1932 3 11.9686 3 9ZM8.25 9C8.25 11.0625 9.9375 12.75 12 12.75C14.0625 12.75 15.75 11.0625 15.75 9C15.75 6.9375 14.0625 5.25 12 5.25C9.9375 5.25 8.25 6.9375 8.25 9Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 9C14.25 10.2188 13.2188 11.25 12 11.25C10.7812 11.25 9.75 10.2188 9.75 9C9.75 7.78125 10.7812 6.75 12 6.75C13.2188 6.75 14.25 7.73438 14.25 9Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationDot);
export default __webpack_public_path__ + "static/media/location-dot.b27a4f41e38c848994cb612550fc0ba2.svg";
export { ForwardRef as ReactComponent };